
export function Distance(coordsA: { lat: number, lng: number }, coordsB: { lat: number, lng: number }, unit: 'K' | 'N' = 'K') {
  if ((coordsA.lat === coordsB.lat) && (coordsA.lng === coordsB.lng)) {
    return 0;
  }
  else {
    var radlat1 = Math.PI * coordsA.lat / 180;
    var radlat2 = Math.PI * coordsB.lat / 180;
    var theta = coordsA.lng - coordsB.lng;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") { dist = dist * 1.609344 }
    if (unit == "N") { dist = dist * 0.8684 }
    return dist;
  }
}